<template>
  <div
    :class="[`weather-widget__block weather-widget__block--middle ${$mq}`]"
    slot="footer"
  >
    <div class="weather-widget__block-item">
      <r-icon name="wind" :color="iconColor" />
      <r-text type="caption" :size="24">
        {{ `${currentWeather.wind || 0} ${$t("ms")}` }}
      </r-text>
    </div>
    <div class="weather-widget__block-item">
      <r-icon name="rain-drop" :color="iconColor" />
      <r-text type="caption" :size="24">
        {{ `${currentWeather.humidity || 0}%` }}
      </r-text>
    </div>
    <div class="weather-widget__block-item">
      <r-icon name="eye" :color="iconColor" />
      <r-text type="caption" :size="24">
        {{ ` ${currentWeather.visibility || 0} ${$t("km")}` }}
      </r-text>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentWeather: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      iconColor: "#8689A2"
    };
  }
};
</script>

<style lang="scss">
.weather-widget {
  &__block {
    &--middle {
      display: flex;
      justify-content: space-between;
      .weather-widget__block-item {
        width: 33.3%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &:nth-child(2) {
          justify-content: center;
        }
        &:last-child {
          justify-content: flex-end;
        }
      }
      .r-text.caption-2 {
        font-weight: 600 !important;
        margin-bottom: 0;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ms": "м/с",
    "km": "км"
  },
  "en": {
    "ms": "ms",
    "km": "km"
  }
}
</i18n>
